module.exports = __webpack_public_path__ + "static/img/icon_94_gonglueadd.491c8190.png";